import { render, staticRenderFns } from "./NotImplemented.vue?vue&type=template&id=71c82824&lang=pug&"
import script from "./NotImplemented.vue?vue&type=script&lang=js&"
export * from "./NotImplemented.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports